"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteMarketSegment = void 0;
var QuoteMarketSegment;
(function (QuoteMarketSegment) {
    QuoteMarketSegment["ENTERPRISE"] = "Enterprise";
    QuoteMarketSegment["MASS_MARKET"] = "Mass Market";
})(QuoteMarketSegment || (exports.QuoteMarketSegment = QuoteMarketSegment = {}));
//# sourceMappingURL=QuoteType.js.map